import { createContext, useReducer } from "react";
import jwtDecode from "jwt-decode";
import { getParamFromToken } from "../Login/Login";
import { clearStorage, getItemFromStorage, setItemInStorage } from "../../utils/utilsFuncs";

export const extractRoleFromToken = (token) => {
  if (token === undefined || token === null || token === "") return "";
  let userRole = JSON.parse(JSON.stringify(jwtDecode(token))).userRole;
  return userRole === undefined ? "" : userRole;
};

const LoginContext = createContext();

let initialState = {
  jwtToken: getItemFromStorage("jwtToken") === null ? "" : getItemFromStorage("jwtToken"),
  userId: getItemFromStorage("userId") === null ? -1 : getItemFromStorage("userId"),
  userName: getItemFromStorage("userName") === null ? "" : getItemFromStorage("userName"),
  userRole: getItemFromStorage("jwtToken") === null ? "" : extractRoleFromToken(getItemFromStorage("jwtToken")),
  userPrivileges: getItemFromStorage("userPrivileges") === null ? [] : getItemFromStorage("userPrivileges"),
};

export const LoginActionType = {
  SET_LOGGED_IN: "SET_LOGGED_IN",
  SET_LOGGED_IN_OUTSIDE_SYSTEM: "SET_LOGGED_IN_OUTSIDE_SYSTEM",
  SET_LOGGED_OUT: "SET_LOGGED_OUT",
  RENEW_TOKEN: "RENEW_TOKEN",
  SET_USER_PRIVILEGES: "SET_USER_PRIVILEGES",
};

function loginReducer(state, action) {
  const newState = { ...state };
  const { token, privileges } =
    action.payload === undefined ? { token: "", userName: "", privileges: [] } : action.payload;
  switch (action.type) {
    case LoginActionType.SET_LOGGED_IN:
    case LoginActionType.SET_LOGGED_IN_OUTSIDE_SYSTEM:
      const userId = JSON.stringify(JSON.parse(JSON.stringify(jwtDecode(token))).userId);
      const userName = getParamFromToken("username", token);
      newState.userId = userId;
      newState.token = token;
      newState.userName = userName;
      newState.userRole = extractRoleFromToken(token);
      newState.userPrivileges = privileges;
      setItemInStorage("jwtToken", token);
      setItemInStorage("userId", userId);
      setItemInStorage("userName", userName);
      setItemInStorage("userPrivileges", privileges);
      setItemInStorage("userRole", newState.userRole);
      break;
    case LoginActionType.SET_USER_PRIVILEGES:
      newState.userPrivileges = privileges;
      setItemInStorage("userPrivileges", privileges);
      break;
    case LoginActionType.SET_LOGGED_OUT:
      newState.token = "";
      newState.userId = "";
      newState.userName = "";
      newState.userRole = "";
      newState.userPrivileges = [];
      const theme = getItemFromStorage("theme");
      clearStorage();
      setItemInStorage("theme", theme);
      break;
    case LoginActionType.RENEW_TOKEN:
      newState.token = action.payload;
      newState.userRole = extractRoleFromToken(action.payload);
      setItemInStorage("jwtToken", action.payload);
      break;
    default:
      return state;
  }
  return newState;
}

function LoginProvider({ children }) {
  const [state, dispatch] = useReducer(loginReducer, initialState);

  const value = { state, dispatch };
  return <LoginContext.Provider value={value}>{children}</LoginContext.Provider>;
}

export { LoginProvider, LoginContext };
